import { render, staticRenderFns } from "./PokemonCardContainer.vue?vue&type=template&id=2f5859c6&"
import script from "./PokemonCardContainer.vue?vue&type=script&lang=ts&"
export * from "./PokemonCardContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports